import { render, staticRenderFns } from "./RoleDetailEdit.vue?vue&type=template&id=1adcd955&scoped=true&"
import script from "./RoleDetailEdit.vue?vue&type=script&lang=js&"
export * from "./RoleDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoleDetailEdit.vue?vue&type=style&index=0&id=1adcd955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adcd955",
  null
  
)

export default component.exports